var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{staticClass:"input-exam",attrs:{"color":"secondary","rules":_vm.rules,"dense":""},model:{value:(_vm.selectedTitle),callback:function ($$v) {_vm.selectedTitle=$$v},expression:"selectedTitle"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }